<template>
    <div class="main-content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="board-main-content">
                        <div class="board-wrapper">
                            <div class="heading" v-if="currentRoom && currentRoom.name == 'Global'">
                                <h1 class="mb-2">HUB Chat</h1>
                                <p class="mb-0">This is the Analyst Hub's global chat.</p>
                                <p>All the System messages here are related to the Hub.</p>
                            </div>
                            <div class="heading" v-else-if="team && team.name">
                                <h1 class="title mb-3" v-if="team && team.name">Team <svg viewBox="0 0 20 20" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 11-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 111.254-1.255L12.74 9.39a.888.888 0 01-.16 1.382l-4.043 4.042z"/></svg> <span class="team-name"><span class="gold-txt blue-hover">{{ team.name }}</span></span> <svg viewBox="0 0 20 20" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 11-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 111.254-1.255L12.74 9.39a.888.888 0 01-.16 1.382l-4.043 4.042z"/></svg> Chat</h1>
                                <p class="mb-0">This is your Team's private Chat.</p>
                                <p>All the System messages here are related to your Team Only.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="message-channels">
                <div class="row">
                    <div class="col-9 col-md-9 col-sm-8 ">
                        <ul>
                            <li :class="{ 'gold' : (currentRoom && currentRoom.name != 'Global'), 'active' : (!$route.query.system_messages && !$route.query.user_messages) }" v-if="! resultsKey">
                                <a href="javascript:" @click="switchFilter('all')">All Messages</a>
                            </li>
                            <li :class="{ 'gold' : (currentRoom && currentRoom.name != 'Global'), 'active' : $route.query.system_messages }" v-if="! resultsKey">
                                <a href="javascript:" @click="switchFilter('system')">System Only</a>
                            </li>
                            <li :class="{ 'gold' : (currentRoom && currentRoom.name != 'Global'), 'active' : $route.query.user_messages }" v-if="! resultsKey">
                                <a href="javascript:" @click="switchFilter('user')" v-if="(currentRoom && currentRoom.name === 'Global')">Users Only</a>
                                <a href="javascript:" @click="switchFilter('user')" v-else>Team Only</a>
                            </li>
                            <li :class="{ 'gold' : (currentRoom && currentRoom.name != 'Global') }" class="active" v-else>Search results for "{{ resultsKey }}"</li>
                        </ul>
                    </div>
                    <div class="col-3 col-md-3 col-sm-4">
                        <div class="chat-search-form search-box"
                             :class="{ 'gold' : (currentRoom && currentRoom.name != 'Global') }">
                            <input type="text" placeholder="Search..."
                                   v-model="searchQuery"
                                   @keydown.enter.exact="searchMessage()"
                            />
                            <button @click="searchMessage()"></button>
                        </div>
                    </div>
                </div>

            </div>
            <div class="message-board" :class="{ 'gold' : (currentRoom && currentRoom.name != 'Global') }" v-if="! resultsKey">
                <div v-if="messages.length > 0">
                    <div class="see-more-comments"
                         v-if="readyLoading && currentPPage > 0 && currentPPage < lastPPage"
                         v-observe-visibility="{
                             callback: visibilityChanged,
                             throttle: 300
                         }">
                        <svg  class="rotate-infinite"
                              xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15"><g><g><path fill="#8e8e93" d="M2.936 5.288l1.65 1.687a.75.75 0 1 1-1.073 1.05l-.36-.367C3.231 10.913 5.834 13.5 9 13.5a5.763 5.763 0 0 0 4.355-1.995.75.75 0 1 1 1.129.99C13.141 14.025 11.184 15 9 15c-4.025 0-7.27-3.292-7.349-7.35l-.365.375a.75.75 0 0 1-1.072-1.05l1.65-1.687a.757.757 0 0 1 .536-.225c.202 0 .395.082.536.225zM9 1.5a5.763 5.763 0 0 0-4.355 1.995.75.75 0 1 1-1.129-.99C4.859.975 6.816 0 9 0c4.025 0 7.27 3.293 7.349 7.35l.365-.375a.75.75 0 0 1 1.072 1.05l-1.65 1.688a.757.757 0 0 1-.536.225.757.757 0 0 1-.536-.225l-1.65-1.688a.75.75 0 0 1 1.073-1.05l.36.368C14.769 4.088 12.166 1.5 9 1.5z"/></g></g></svg>
                    </div>
                    <div class="comment-list-box" v-for="(message, index) in messages" :key="index">
                    <div class="user-img">
                        <avatar v-if="message.user.photo"
                                :src="'/storage/' + message.user.photo"
                                :username="message.user.name"
                                class="user-img"
                                :size="44"></avatar>
                        <avatar v-else
                                :username="message.user.name"
                                class="user-img"
                                :size="44"></avatar>
                    </div>
                    <div class="user-comment-info">
                        <h6><span :class="{ 'sys-user-name' : message.system_user }">{{ message.user.name }}</span> <span class="date">{{ message.created_at  | moment("D MMMM YYYY") }}</span>
                        </h6>
                        <p v-html="message.message"></p>
                    </div>
                </div>
                </div>
            </div>
            <div class="message-board" :class="{ 'gold' : (currentRoom && currentRoom.name != 'Global') }" v-else>
                <div v-if="searchResults.length"
                     class="comment-list-box"
                     v-for="(message, index) in searchResults.slice().reverse()" :key="index">
                    <div class="user-img">
                        <avatar :src="'/storage/' + message.user.photo"
                                :username="message.user.name"
                                class="user-img"
                                :size="44"></avatar>
                    </div>
                    <div class="user-comment-info">
                        <h6><span :class="{ 'sys-user-name' : message.system_user }">{{ message.user.name }}</span> <span class="date">{{ message.created_at  | moment("D MMMM YYYY") }}</span>
                        </h6>
                        <p v-html="message.message"></p>
                    </div>
                </div>
                <div v-if="! searchResults.length"
                     class="user-comment-info">
                    <p>No results found for search key "<b>{{ resultsKey }}</b>".</p>
                </div>
            </div>
            <hr class="mt-0" />

            <div class="leave-comment-part" v-if="! resultsKey">
                <div class="leave-comment-title">
                    <h3>LEAVE A MESSAGE</h3>
                    <div class="social-stats active">
                        <span><img src="/assets/img/user_account_profile.svg" alt="" width="16" />
                            <span class="user-count">{{ usersCount || 1 }}</span>
                        </span>
                    </div>
                </div>
                <textarea rows="4" class="form-control rounded message-input"
                          :class="{ 'gold' : (currentRoom && currentRoom.name != 'Global') }"
                          v-model="message"
                          placeholder="Write your notes here..."></textarea>

                <button class="btn btn-sm-alternative-primary mt-3"
                        :class="{ 'gold' : (currentRoom && currentRoom.name != 'Global') }"
                        :disabled="!message || busy"
                        @click="addMessage(); busy = true;"><img
                    src="/assets/img/post-comment-icon.svg" alt="" width="21">Send
                </button>
            </div>
            <div class="leave-comment-part" v-if="resultsKey">

                <button class="btn btn-sm-alternative-primary mt-3"
                        :class="{ 'gold' : (currentRoom && currentRoom.name != 'Global') }"
                        @click="resetSearch(true); ">Back
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from 'vue-avatar';
import ApiService from "../../api/api.service";
export default {
    name: "ChatHome",
    components: {
        Avatar,
    },
    data: () => {
        return {
            roomId: null,
            message: '',
            messages: [],
            rooms: [],
            currentRoom: null,
            team: null,
            membersCount: null,
            usersCount: null,
            users: [],
            searchQuery: null,
            resultsKey: null,
            searchResults: [],

            currentPPage: 0,
            lastPPage: 1,
            busy: false,
            scrollPosition: null,
            loaded: null,
            systemMessagesOnly: null,
            readyLoading: false,
        };
    },
    created() {
        if(!this.$route.query.id) {
            this.goToGlobalRoom();
        } else {
            this.connect();
        }
    },
    mounted() {
        window.setInterval(() => {
            this.getOnlineUsersCount();
        }, 10000);

        if(this.$route.query.system_messages) {
            this.systemMessagesOnly = 'system';
        } else if(this.$route.query.user_messages) {
            this.systemMessagesOnly = 'user';
        } else {
            this.systemMessagesOnly = null;
        }
    },
    watch: {
        '$route' (newValue, oldValue) {

            if(oldValue.path == '/chat' && newValue.path == '/chat' && oldValue.query.id != newValue.query.id) {
                Echo.leave('chat.' + oldValue.query.id + this.currentRoom.token);

                this.systemMessagesOnly = null;
                this.currentPPage = 0;
                this.lastPPage = 1;
                this.busy = false;
                this.connect();

                // update last visited of that chat
                if(newValue.query.id) {
                    this.updateRoomVisited(newValue.query.id);
                }

            }

        }
    },
    methods: {
        connect() {
            this.resetSearch();

            if(this.roomId = this.$route.query.id) {
                if(! this.rooms.length) {
                    this.getRooms();
                } else {
                    this.setCurrentRoom(this.rooms);
                }
            }
        },

        initialLoadPusher() {
            let vm = this;
            this.loadMessages(true);
            Echo.channel('chat.' + this.roomId + this.currentRoom.token)
                .listen('.new-message', function(data) {
                    vm.loadMessages(true);
                });

            this.getOnlineUsersCount();
        },

        disconnect() {
            Echo.leave('chat.' + this.roomId + this.currentRoom.token);
        },
        loadMessages(first = false) {
            if(first) {
                this.currentPPage = 0;
                this.lastPPage = 1;
            }
            if(this.currentPPage == this.lastPPage) {
                return;
            }

            let params = null;
            if(this.systemMessagesOnly && this.systemMessagesOnly == 'system') {
                params = {
                    page: this.currentPPage + 1,
                    system_messages: 'on'
                };
            } else if(this.systemMessagesOnly && this.systemMessagesOnly == 'user') {
                params = {
                    page: this.currentPPage + 1,
                    user_messages: 'on'
                };
            } else {
                params = {
                    page: this.currentPPage + 1
                };
            }
            this.busy = true;
            setTimeout(() => {
                ApiService.setHeader();
                ApiService.post('/api/chat/room/' + this.roomId + '/messages', params)
                    .then(({data}) => {
                        this.messagesPagination = data;

                        if (data.current_page === 1) {
                            this.messages = data.data.slice().reverse();

                            // Mark messages viewed count
                            this.updateRoomVisited(this.roomId)
                        } else {
                            let newMessages = data.data;
                            for (let i = 0; i < newMessages.length; i++) {
                                this.messages.unshift(newMessages[i]);
                                // this.scrollToEnd(20);
                            }
                            this.readyLoading = false;

                        }

                        this.currentPPage = data.current_page;
                        this.lastPPage = data.last_page;
                        this.busy = false;

                        if(this.currentPPage < 2) {
                            setTimeout(() => {
                                this.scrollToEnd();
                            }, 100);
                        }

                        setTimeout(() => {
                            this.readyLoading = true;
                        }, 500);

                        this.getOnlineUsersCount();
                    })
                    .catch((response) => {
                        this.busy = false;
                    });
            }, 100);


        },
        getOnlineUsersCount() {
            ApiService.setHeader();
            ApiService.get('/api/chat/room/' + this.roomId + '/count')
                .then((response) => {
                    this.usersCount = response.data[0].connection_count;
                })
                .catch();
        },
        addMessage() {
            if(!this.message.trim()) {
                return;
            }

            ApiService.setHeader();
            ApiService.post('/api/chat/room/' + this.roomId + '/message',
                {
                    message: this.message,
                })
                .then(({data}) => {
                    this.message = '';
                    this.loadMessages(true);
                    this.busy = false;
                })
                .catch();
        },
        goToGlobalRoom() {
            this.getRooms();
        },

        getRooms() {
            ApiService.setHeader();
            ApiService.get('/api/chat/rooms')
                .then(({data}) => {
                    this.rooms = data.rooms;

                    if(this.$route.query.id) {
                        this.setCurrentRoom(data.rooms);
                    } else {
                        if(this.rooms.length > 0) {
                            this.rooms.forEach((room) => {
                                if(room.name == 'Global') {
                                    this.currentRoom = room;
                                    this.$router.push({ path: 'chat', query: { id: room.id }})
                                }
                            })
                            //
                            this.roomId = this.$route.query.id;
                            this.message = '';


                        }
                    }

                })
                .catch();
        },

        setCurrentRoom(rooms) {
            rooms.forEach((room) => {
                if(room.id == this.$route.query.id) {
                    this.currentRoom = room;
                    if(this.currentRoom.team_id) {
                        this.getTeamInfo(this.currentRoom.team_id)
                    }
                }
            })

            if(! this.currentRoom) {
                this.rooms.forEach((room) => {
                    if(room.name == 'Global') {
                        this.currentRoom = room;
                        this.$router.push({ path: 'chat', query: { id: room.id }})
                    }
                })
            }

            this.initialLoadPusher();
        },

        getTeamInfo(teamId) {
            ApiService.setHeader();
            ApiService.get('/api/teams/' + teamId)
                .then(({data}) => {
                    this.team = data.team;
                })
                .catch((response) => {
                    console.log(response);
                })
        },

        scrollToEnd: function(partial) {
            let container = this.$el.querySelector(".message-board");
            if(partial) {
                container.scrollTop(y + partial);
            } else {
                container.scrollTop = container.scrollHeight;
            }
        },

        searchMessage: function() {
            if(this.searchQuery) {
                ApiService.setHeader();
                ApiService.post('/api/chat/room/' + this.roomId + '/search',
                    {key: this.searchQuery}
                )
                    .then(({data}) => {
                        this.searchResults = data.results;
                        this.resultsKey = data.key;
                    })
                    .catch();
            }
        },

        resetSearch(connect = false) {
            this.searchResults = [];
            this.searchQuery = this.resultsKey = null;

            if(connect) {
                setTimeout(() => {
                    this.scrollToEnd();
                }, 100)
            }
        },

        visibilityChanged(isVisible, entry) {
            if(isVisible && entry.time > 3000) {
                this.loadMessages();
            }
        },

        updateRoomVisited(roomId) {
            ApiService.setHeader();
            ApiService.post('/api/chat/room/' + roomId + '/visits')
                .then(({data}) => {
                    // console.log(data);
                })
                .catch();

        },

        switchFilter(filter) {
            if(filter == 'system') {
                this.systemMessagesOnly = filter;
                this.$router.push({ path: 'chat', query: { id: this.roomId, system_messages: 'on' }})
            } else if(filter == 'user') {
                this.systemMessagesOnly = filter;
                this.$router.push({ path: 'chat', query: { id: this.roomId, user_messages: 'on' }})
            } else {
                this.systemMessagesOnly = false;
                this.$router.push({ path: 'chat', query: { id: this.roomId}})
            }

            this.connect();
            this.scrollToEnd();
        }

    }
}
</script>

<style scoped>
input.message-input, textarea.form-control, input.form-control {
    resize: none;
    overflow: hidden;
    min-height: 50px !important;
    font-family: "Poppins", sans-serif !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    color: #16181F !important;
}

.message-board {
    min-height: calc(100vh - 480px);
    max-height: calc(100vh - 460px);
    overflow-y: auto;
    padding-top: 10px;
}

.message-board .user-comment-info p {
    font-size: 16px !important;
    white-space:pre-wrap;
}

.message-channels {
    margin-bottom: -20px;
}

.message-channels ul {
    list-style-type: none;
    margin-bottom: 0px;
    border-bottom: 1px solid #DFDFDF;
}

.message-channels ul li {
    display: inline-block;
    margin-right: 10px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
}
.message-channels ul li a {
    color: #6e7077;
}

.message-channels ul li.active a, .message-channels ul li a:hover{
    color: #1E73BD;
}
.message-channels ul li.active, .message-channels ul li:hover {
    border-bottom: 2px solid #1E73BD;
}
.message-channels ul li.active.gold a, .message-channels ul li.gold a:hover{
    color: #ba8c00;
}
.message-channels ul li.active.gold, .message-channels ul li.gold:hover {
    border-bottom: 2px solid #ba8c00;
}


.btn-sm-alternative-primary {
    background-color: #1E73BD;
    border-color: #1E73BD;
}
.btn-sm-alternative-primary.gold {
    background-color: #ba8c00;
    border-color: #ba8c00;
}


.gold-txt {
    color: #ba8c00;
}

textarea.gold:hover, textarea.gold:focus {
    border-color: #ba8c00;
}
.chat-search-form:hover {
    border-color: #1e73bd;
}

.chat-search-form.gold:hover {
    border-color: #ba8c00;
}
.gold-bg {
    background-color: #ba8c00;
}

/*input.search-icon {*/
/*    background-image: url(/assets/img/search-icon-hover.svg);*/
/*    background-repeat: no-repeat;*/
/*    background-position: right 10px center;*/
/*}*/

.chat-search-form {
    display:flex;
    flex-direction:row;

    /* This bit draws the box around it */
    height: 48px;
    border-radius: 4px;
    border: 1px solid #DFDFDF;

    /* I've used padding so you can see the edges of the elements. */
    padding:2px;
}

.chat-search-form input {
    /* Tell the input to use all the available space */
    flex-grow:2;
    /* And hide the input's outline, so the form looks like the outline */
    border:none;
    height:44px;
    resize: none;
    overflow: hidden;
    font-family: "Poppins", sans-serif !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    color: #16181F !important;
    padding: 0.375rem 0.75rem;
}

.chat-search-form input:focus {
    /* removing the input focus blue box. Put this on the form if you like. */
    outline: none;
}

.chat-search-form button {
    border: none;
    padding-right: 4px;
    background-color: #ffffff;
    margin-right: 1px;
    border-radius: 5px;
}

span.red-badge {
    font-weight: 300;
    font-size: 14px
}
span.user-count {
    margin: auto 3px auto -2px;
    padding-top: 2px;
    font-weight: 300;
    font-size: 16px;
}

.sys-user-name {
    color: #245e95;
}

.leave-comment-part {
    margin-bottom:20px;
}

</style>
